<template>
  <div class="pin-skeleton-container">
    <div class="pin-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
      <Skeleton height="18px" width="216px" borderRadius="4px" />
    </div>
    <div class="pin-skeleton-container-main">
      <div class="pin-skeleton-container-main-content">
        <div class="pin-skeleton-container-main-content-top">
          <Skeleton height="40px" width="481px" borderRadius="4px" />
          <Skeleton height="40px" width="481px" borderRadius="4px" />
        </div>
        <div class="pin-skeleton-container-main-content-bottom">
          <Skeleton height="40px" fullWidth borderRadius="4px" />
          <Skeleton height="14px" width="457px" borderRadius="4px" />
        </div>
      </div>
      <div class="pin-skeleton-container-main-footer">
        <div class="pin-skeleton-container-main-footer-right">
          <Skeleton width="212px" height="40px" borderRadius="6px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pin-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;

  &-header,
  &-main,
  &-main-content,
  &-main-footer {
    align-self: stretch;
  }

  &-header,
  &-main-content-top,
  &-main-footer,
  &-main-footer-right {
    display: flex;
    align-items: center;
  }

  &-main,
  &-main-content,
  &-main-content-bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 16px 24px 24px 24px;
    gap: 16px;

    &-content {
      gap: 16px;

      &-top {
        align-items: flex-start;
        gap: 24px;
        align-self: stretch;
      }

      &-bottom {
        width: 481px;
        align-items: flex-end;
        gap: 4px;
      }
    }

    &-footer {
      justify-content: flex-end;
      gap: 16px;

      &-right {
        justify-content: center;
        gap: 2px;
      }
    }
  }
}
</style>
